import { useNavigate } from 'react-router-dom';
import { formatFieldValue } from '@/components/feature/GreenCertFieldConfig';
import type { SupplyItem, DemandItem } from '@/services/api';

type Row = SupplyItem | DemandItem;

interface Props {
  items: Row[];
  kind: 'supply' | 'demand';
  onMessageClick: (item: Row) => void;
}

export default function ListingTable({ items, kind, onMessageClick }: Props) {
  const navigate = useNavigate();
  const priceLabel = (item: Row) =>
    item.price && item.price.trim() !== '' ? `¥${item.price}` : '对方出价';

  return (
    <div className="mt-6 overflow-x-auto border border-background-200 rounded-lg">
      <table className="w-full text-sm whitespace-nowrap">
        <thead className="bg-background-100 text-foreground-500">
          <tr>
            <th className="px-3 py-3 text-left font-medium">序号</th>
            <th className="px-3 py-3 text-left font-medium">年份</th>
            <th className="px-3 py-3 text-left font-medium">项目类型</th>
            <th className="px-3 py-3 text-left font-medium">通道</th>
            <th className="px-3 py-3 text-left font-medium">补贴</th>
            <th className="px-3 py-3 text-right font-medium">张数</th>
            <th className="px-3 py-3 text-right font-medium">价格</th>
            <th className="px-3 py-3 text-left font-medium">交易方式</th>
            <th className="px-3 py-3 text-left font-medium">交易所</th>
            <th className="px-3 py-3 text-left font-medium">信息有效期</th>
            <th className="px-3 py-3 text-left font-medium">企业名称</th>
            <th className="px-3 py-3 text-center font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr
              key={item.id}
              onClick={() => navigate(`/detail/${kind}/${item.id}`)}
              className="border-t border-background-100 hover:bg-background-50 cursor-pointer transition-colors"
            >
              <td className="px-3 py-3 text-foreground-400">{idx + 1}</td>
              <td className="px-3 py-3 text-foreground-700">{item.year}</td>
              <td className="px-3 py-3 text-foreground-700">{formatFieldValue('projectType', item.projectType)}</td>
              <td className="px-3 py-3 text-foreground-600">{formatFieldValue('channel', item.channel)}</td>
              <td className="px-3 py-3 text-foreground-600">{formatFieldValue('subsidy', item.subsidy)}</td>
              <td className="px-3 py-3 text-right text-foreground-900 font-medium">{item.quantity.toLocaleString()}</td>
              <td className="px-3 py-3 text-right text-foreground-900 font-medium">{priceLabel(item)}</td>
              <td className="px-3 py-3 text-foreground-600">{formatFieldValue('tradeMethod', item.tradeMethod)}</td>
              <td className="px-3 py-3 text-foreground-600">{formatFieldValue('exchange', item.exchange)}</td>
              <td className="px-3 py-3 text-foreground-600">{item.expiryDate}</td>
              <td className="px-3 py-3 text-foreground-600">{item.company}</td>
              <td className="px-3 py-3 text-center">
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); onMessageClick(item); }}
                  className="px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-chat-3-line mr-1"></i>发站内信
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
